import DlAnimate from 'dl-animate/dist/dl-animate-module';
import { TweenLite } from 'gsap/TweenLite';
import toggleModal from '@/scripts/utils/toggle-modal';

const dlAnimate = new DlAnimate();


class HeaderNav {
  constructor(options) {
    this.menuSelector = options.menuSelector;
    this.menu = document.querySelector(options.menuSelector);
    this.menuContainer = document.querySelector(options.menuContainer); // inner
    this.menuScrollContainer = options.menuScrollContainer; // scrollable
    this.menuWrapperSelector = options.menuWrapper; // outer
    this.menuListSelector = options.menuList;
    this.menuList = this.menuContainer.querySelector(options.menuList);
    this.menuListItemSelector = options.menuListItem;
    this.transitionDuration = options.transitionDuration;
    this.menuTitle = this.menuContainer.querySelector(options.menuTitle);
    this.menuTitleText = this.menuTitle.querySelector('span');
    if (options.menuItemDecoration) {
      this.menuItemDecoration = options.menuItemDecoration;
    }
    this.transitionDelay = 40;
  }

  openInner(e) {
    this.reInit();
    const item = e.target.closest(this.menuListItemSelector) || e.target;
    const list = item.querySelector(this.menuListSelector).cloneNode(true);
    const thisList = Array.from(item.closest(this.menuListSelector).children);
    const newList = Array.from(list.children);
    const listTitle = item.querySelector(`span:not(${this.menuItemDecoration})`).innerHTML;
    const duration = this.transitionDuration + Math.max(thisList.length, newList.length) * this.transitionDelay;
    this.scrollToTop(true);
    this.addDelayForward(thisList, newList, item);

    dlAnimate.hide(this.menuList, {
      name: 'menu',
      track: 'none',
      duration,
      beforeLeave: () => {
        this.menuTitle.classList.add('is-disabled');
        this.menuTitle.classList.remove('is-hidden');
        this.menuTitleText.innerHTML = listTitle;
        dlAnimate.insert(this.menuContainer, list, {
          name: 'menu',
          track: 'none',
          duration,
          beforeEnter: (nextList) => {
            this.refreshList(nextList);
            HeaderNav.toggleClasses(nextList);
            nextList.setAttribute('data-title', listTitle);
          },
          afterEnter: () => {
            this.menuTitle.classList.remove('is-disabled');
          },
        }, this.menuContainer.getElementsByTagName(this.menuListSelector)[0]);
      },
    });
  }

  goBack() {
    if (this.menuTitle.classList.contains('is-disabled')) return false;
    this.menuTitle.classList.add('is-disabled');
    this.reInit();
    const PREV_LISTS = this.menuContainer.querySelectorAll('.top-list');
    const thisList = Array.from(PREV_LISTS[0].children);
    const newList = Array.from(PREV_LISTS[1].children);
    const duration = this.transitionDuration + Math.max(thisList.length, newList.length) * this.transitionDelay + 20;

    this.addDelayBack(thisList, newList);

    return dlAnimate.remove(PREV_LISTS[0], {
      name: 'menu-back',
      track: 'none',
      duration,
      beforeLeave: () => {
        dlAnimate.show(PREV_LISTS[1], {
          name: 'menu-back',
          track: 'none',
          duration,
          beforeEnter: (nextList) => {
            HeaderNav.toggleClasses(nextList);
            const { title } = nextList.dataset;
            if (title) {
              this.menuTitleText.innerHTML = title;
            } else {
              this.menuTitle.classList.add('is-hidden');
            }
          },
          afterEnter: () => {
            this.menuTitle.classList.remove('is-disabled');
          },
        });
      },
      afterLeave: (prevList) => {
        $(prevList).remove();
      },
    });
  }

  static toggleClasses(list) {
    Array.from(list.children).forEach((item) => {
      item.classList.add('is-hidden');
      item.addEventListener('animationstart', () => {
        item.classList.remove('is-hidden');
      }, { once: true });
    });
  }

  addDelayBack(thisList, newList) {
    let mult = 1;
    const lengthForward = Math.max(thisList.length, newList.length);
    for (let i = 0; i < lengthForward; i += 1) {
      if (thisList[i]) {
        thisList[i].style.animationDelay = `${Math.abs(mult * this.transitionDelay)}ms`; // eslint-disable-line no-param-reassign
      }
      if (newList[i]) {
        newList[i].style.animationDelay = `${Math.abs(mult * this.transitionDelay)}ms`; // eslint-disable-line no-param-reassign
      }
      mult += 1;
    }
  }

  addDelayForward(thisList, newList, thisItem) {
    const itemIndex = thisList.indexOf(thisItem);

    thisItem.style.animationDelay = '0ms'; // eslint-disable-line no-param-reassign

    let multBack = 1;
    for (let i = itemIndex - 1; i >= 0; i -= 1) {
      if (thisList[i]) {
        thisList[i].style.animationDelay = `${Math.abs(multBack * this.transitionDelay)}ms`; // eslint-disable-line no-param-reassign
      }
      if (newList[i]) {
        newList[i].style.animationDelay = `${Math.abs(multBack * this.transitionDelay)}ms`; // eslint-disable-line no-param-reassign
      }
      multBack += 1;
    }

    let multForward = 1;
    const lengthForward = Math.max(thisList.length, newList.length);
    for (let j = itemIndex + 1; j < lengthForward; j += 1) {
      if (thisList[j]) {
        thisList[j].style.animationDelay = `${Math.abs(multForward * this.transitionDelay)}ms`; // eslint-disable-line no-param-reassign
      }
      if (newList[j]) {
        newList[j].style.animationDelay = `${Math.abs(multForward * this.transitionDelay)}ms`; // eslint-disable-line no-param-reassign
      }
      multForward += 1;
    }
  }

  toggleStatus() {
    const header = document.querySelector('header');
    header.classList.toggle('opened');
    document.documentElement.classList.toggle('menu-opened');
    this.scrollToTop();
    return toggleModal(header.classList.contains('opened'), this.menuScrollContainer, this.menu);
  }

  scrollToTop() {
    return TweenLite.to(
      this.menuScrollContainer,
      this.transitionDuration / 1000 * 0.5,
      {
        scrollTo: { y: 0, autoKill: false },
      },
    );
  }

  refreshList(list) {
    list.classList.add('top-list');
    Array.from(list.querySelectorAll(this.menuListItemSelector)).forEach((el) => {
      if ($(el).closest(this.menuListSelector).hasClass('top-list')) el.classList.add('top-item');
      if (el.classList.contains('has-children')) {
        $(el).append($(`
          <span class="dots">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </span>        
        `));
        el.addEventListener('click', (e) => {
          this.openInner(e);
        });
      }
    });
  }

  init() {
    this.refreshList(this.menuList);
    this.menuTitle.addEventListener('click', (e) => {
      this.goBack(e);
    });
    document.querySelector('[data-role*="main-menu-trigger"]').addEventListener('click', (e) => {
      this.toggleStatus(e);
    }, false);
    document.addEventListener('click', (e) => {
      const header = document.querySelector('header');
      if (!e.target.closest(this.menuWrapperSelector)
        && header.classList.contains('opened')) {
        this.toggleStatus();
      }
    });
  }

  reInit() {
    this.menuList = this.menuContainer.querySelector(this.menuListSelector);
  }
}

export default function initHeaderNav(options) {
  const defaults = {
    menuSelector: '.menu',
    menuScrollContainer: '.menu',
    menuContainer: '.menu__container', // inner
    menuWrapper: '.menu__wrapper', // outer
    menuList: 'ul',
    menuListItem: 'li',
    menuTitle: '.menu__title',
    menuItemDecoration: '.line',
    transitionDuration: 450,
  };
  const headerNav = new HeaderNav(Object.assign({}, defaults, options));
  headerNav.init();
}



// WEBPACK FOOTER //
// ./scripts/elements/header-nav.js